var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',[_vm._v("我也是有底线的哦")]),_c('img',{attrs:{"src":require("../../assets/icons/smile.png"),"lazy-load":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }